import * as React from "react";
import { IParagraphSailDatesProps } from "./ParagraphSailDatesProps";
import { Container } from "./ParagraphSailDatesHelpers";
import { graphql } from "gatsby";
import SailDates from "../../common/SailDates/SailDates";

const ParagraphSailDates: React.FC<IParagraphSailDatesProps> = (props) => {
  return (
    <Container>
      <SailDates {...props.node} />
    </Container>
  );
};
export const fragment = graphql`
  fragment ParagraphSailDates on paragraph__sail_dates {
    id
    field_embarkation_date
    field_disembarkation_date
    field_rooms_rates_link {
      url
    }
    relationships {
      field_city {
        name
      }
      field_disembarkation_city {
        name
      }
    }
  }
`;
export default ParagraphSailDates;
